
export const evinaConfig = {
    evinaClientId: '3f5fbd11-70e3-44d6-b2ec-cd1a1302885c',
    evinaClientSecret: 'tVIXRGvvpub9QFKhNpw9KcULHNdWO7Oy',
};

export const safaricomConfig = {
    host: 'https://api-safaricom.penrosekenya.com',
    authHeader: process.env.VUE_APP_SAFARICOM_AUTH_HEADER,
};

export const campaignConfig = {
    host: `https://campaign-hub.penroseza.com`,
}

export const dcbConfig = {
    host: `https://api.quizinc.co.za`
}

export const fantasyConfig = {
    pricePoint: 20,
    offerCode: '001050038026'
}

export const rushGamesConfig = {
    pricePoint: 20,
    offerCode: '001050038013'
}

export const blgConfig = {
    pricePoint: 20,
    offerCode: '001050038012'
}